'use client'
import React from 'react'
import styles from './styles.module.scss'
import { LoadingSpinner } from '../LoadingSpinner'

interface LoadingWithContainerProps {
  marginTop?: string
}

const LoadingWithContainer: React.FC<LoadingWithContainerProps> = ({
  marginTop,
}) => {
  return (
    <div className={styles.container} style={{ marginTop }}>
      <LoadingSpinner />
    </div>
  )
}

export default LoadingWithContainer
